import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps, Row, Table, Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';

import { BENEFIT_STATUS_LABEL } from '../../constants/benefits';
import {
  Benefit,
  BenefitStatus,
  BenefitSubscription,
} from '../../types/customer';

type BenefitSubscriptionsTableProps = {
  benefit: Benefit;
  onSelectSubscription: (subscription: BenefitSubscription) => void;
};

export const BenefitSubscriptionsTable: React.FC<
  BenefitSubscriptionsTableProps
> = ({ benefit, onSelectSubscription }) => {
  const getActionItems = (
    subscription: BenefitSubscription
  ): MenuProps['items'] => [
    {
      key: subscription.isActiveBenefit ? 'deactivate' : 'reactivate',
      label: subscription.isActiveBenefit ? 'Desativar' : 'Reativar',
      danger: subscription.isActiveBenefit,
    },
  ];

  const columns: ColumnsType<BenefitSubscription> = [
    {
      title: 'ID Assinatura',
      dataIndex: 'id',
      key: 'id',
      width: 140,
    },
    {
      title: 'ID Produto',
      dataIndex: ['productSellGroup', 'id'],
      key: 'productId',
      width: 120,
    },
    {
      title: 'Nome Produto',
      dataIndex: ['productSellGroup', 'name'],
      key: 'productName',
    },
    {
      title: 'ID Oferta',
      dataIndex: ['offer', 'id'],
      key: 'offerId',
      width: 120,
    },
    {
      title: 'Nome da Oferta',
      dataIndex: ['offer', 'name'],
      key: 'offerName',
    },
    {
      title: `Status ${benefit.name}`,
      dataIndex: 'statusBenefit',
      key: 'statusBenefit',
      width: 220,
      render: (status: string) =>
        BENEFIT_STATUS_LABEL[status as BenefitStatus] ?? status,
    },
    {
      title: 'Optante?',
      dataIndex: 'isActiveBenefit',
      key: 'isActiveBenefit',
      width: 120,
      render: (isActiveBenefit: boolean) => {
        const color = isActiveBenefit ? '#52c41a' : '#ff4d4f';

        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}
          >
            <Tag
              style={{
                background: 'transparent',
                borderColor: color,
                color,
              }}
            >
              {isActiveBenefit ? 'Sim' : 'Não'}
            </Tag>
          </div>
        );
      },
    },
    {
      title: 'Ações',
      key: 'actions',
      fixed: 'right',
      width: 80,
      render: (_, subscription) => (
        <Row justify='center'>
          <Dropdown
            menu={{
              items: getActionItems(subscription),
              onClick: () => onSelectSubscription(subscription),
            }}
            placement='bottomRight'
            trigger={['click']}
          >
            <Button
              type='text'
              aria-label={`Ações da assinatura ${subscription.id}`}
              icon={<MoreOutlined />}
            />
          </Dropdown>
        </Row>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={benefit.subscriptions}
      rowKey='id'
      pagination={false}
      scroll={{ x: 1310 }}
      locale={{ emptyText: 'Não há dados' }}
    />
  );
};
